import{u as e}from"./useStorageState-fcf24ebe.js";var o=function(o,r,t){var a="undefined"!=typeof window?window.localStorage:void 0;return e(o,r,a,t)};export{o as u};
//# sourceMappingURL=useLocalStorageState-9fabeed3.js.map
